import { jwtDecode } from 'jwt-decode'

import { getUserIdentity } from './auth'

// Shop-partner clients (FGTAFO, BIMPLI, ...) are identified server-side by a
// national identifier prefixed with the partner name (see
// IdentitySerializer#is_shop_partner). We read that flag from the identity
// endpoint to decide whether to redirect them to the shop app.
// This check runs on the sign-in critical path, ahead of the redirect, so we
// cap it like isAffiliate does: a slow/hung identity endpoint must fall back to
// the default flow rather than stall the redirect for every user. A hanging
// request never rejects, so without this timeout the try/catch would not help.
const TIMEOUT = 1000

export const isShopPartner = async (accessToken: string): Promise<boolean> => {
  try {
    const { sub } = jwtDecode<{ sub?: string }>(accessToken)
    if (!sub) {
      return false
    }
    const identity = await getUserIdentity(sub, accessToken, { timeout: TIMEOUT })
    return identity.is_shop_partner === true
  } catch {
    return false
  }
}
